export class ProfileImageLoad {
    static readonly type = '[UserProfile] imageLoad';

    constructor(public payload: {aboNum: string; partyId: string} = {aboNum: null, partyId: null}) { }
  }
